module.exports = __webpack_public_path__ + "img/cancel-icon.e74103f4.svg";